import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["selectAll", "row", "banner", "count"]
  static values = {
    noun: String,
    highlight: String,
    reviewUrl: String,
    supplierLock: Boolean,
  }

  toggle(event) {
    event.stopPropagation()
    this.highlightRow(event.target.closest("tr"), event.target.checked)
    this.updateSelectAll()
    this.updateCount()
    if (this.supplierLockValue) this.updateSupplierLock()
  }

  toggleAll() {
    const checked = this.selectAllTarget.checked
    this.enabledRows().forEach(checkbox => {
      checkbox.checked = checked
      this.highlightRow(checkbox.closest("tr"), checked)
    })
    this.updateCount()
    if (this.supplierLockValue) this.updateSupplierLock()
  }

  reviewSelected() {
    const ids = this.rowTargets.filter(c => c.checked).map(c => c.value)
    if (ids.length === 0) return
    const params = ids.map(id => `invoice_ids[]=${id}`).join("&")
    window.Turbo.visit(this.withFilterParams(`${this.reviewUrlValue}?${params}`))
  }

  highlightRow(row, selected) {
    row.querySelectorAll("td").forEach(td => {
      td.classList.toggle(this.highlightValue, selected)
    })
    row.classList.toggle("border-blue-100", selected)
    row.classList.toggle("border-neutral-100", !selected)
  }

  updateSelectAll() {
    const enabled = this.enabledRows()
    const selected = enabled.filter(c => c.checked).length
    this.selectAllTarget.checked = enabled.length > 0 && selected === enabled.length
    this.selectAllTarget.indeterminate = selected > 0 && selected < enabled.length
  }

  updateCount() {
    const selected = this.rowTargets.filter(c => c.checked).length
    const noun = this.nounValue
    const label = selected === 1 ? noun : `${noun}s`
    this.countTarget.textContent = `${selected} ${label} selected`
    this.bannerTarget.classList.toggle("hidden", selected === 0)
  }

  updateSupplierLock() {
    const selectedRows = this.rowTargets.filter(c => c.checked)
    const selectedSupplierIds = [...new Set(selectedRows.map(c => c.closest("tr").dataset.supplierId))]

    if (selectedSupplierIds.length === 0) {
      this.rowTargets.forEach(checkbox => {
        checkbox.disabled = false
        checkbox.closest("tr").classList.remove("opacity-40")
      })
      return
    }

    const lockedSupplierId = selectedSupplierIds[0]
    this.rowTargets.forEach(checkbox => {
      const row = checkbox.closest("tr")
      const supplierId = row.dataset.supplierId
      if (supplierId !== lockedSupplierId) {
        checkbox.disabled = true
        checkbox.checked = false
        row.classList.add("opacity-40")
        this.highlightRow(row, false)
      } else {
        checkbox.disabled = false
        row.classList.remove("opacity-40")
      }
    })
  }

  enabledRows() {
    return this.rowTargets.filter(c => !c.disabled)
  }

  withFilterParams(url) {
    const currentParams = new URLSearchParams(window.location.search)
    const targetUrl = new URL(url, window.location.origin)
    const existingKeys = new Set(targetUrl.searchParams.keys())

    for (const [key, value] of currentParams) {
      if (key !== "page" && !existingKeys.has(key)) {
        targetUrl.searchParams.append(key, value)
      }
    }

    return targetUrl.pathname + targetUrl.search
  }
}
